// src/components/Header.js

import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { auth } from "../firebase";
import SeasonSelector from "./SeasonSelector";

const Header = ({ user, roles, clubName }) => {
    const handleLogout = () => { auth.signOut(); };

    return (
        <Navbar bg="dark" variant="dark" expand="lg" style={{ paddingTop: '0.25rem', paddingBottom: '0.25rem' }}>
            <Container>
                <Navbar.Brand as={Link} to="/" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    fontWeight: '600',
                    fontSize: '1.3rem',
                    color: '#fff',
                    marginBottom: 0
                }}>
                    <img
                        src="/rugbycore-logo.png"
                        alt="RugbyCore Logo"
                        style={{ height: '35px', width: 'auto' }}
                    />
                    {clubName && clubName !== "RugbyCore" && (
                        <span style={{
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            color: '#f1f1f1'
                        }}>
                            {clubName}
                        </span>
                    )}
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Home</Nav.Link>
                        {roles.includes("super_admin") && (<Nav.Link as={Link} to="/admin">Admin Dashboard</Nav.Link>)}
                        <NavDropdown title="Matches" id="matches-dropdown">
                            <NavDropdown.Item as={Link} to="/fixtures">Fixtures</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/results">Results</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/all-matches">All Matches (Season)</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/tables">Tables</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/insights">Insights & Analytics</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/minis">Minis Fixtures</NavDropdown.Item>
                        </NavDropdown>
                        {(roles.includes("super_admin") || roles.includes("club_social")) && (<Nav.Link as={Link} to="/pr">PR</Nav.Link>)}
                        {(roles.includes("club_admin") || roles.includes("super_admin")) && (
                            <NavDropdown title="Club" id="club-dropdown">
                                {/* Existing Club Admin items */}
                                {roles.includes("club_admin") && (<NavDropdown.Item as={Link} to="/volunteerRoles"> Manage Volunteer Roles </NavDropdown.Item>)}
                                {roles.includes("club_admin") && (<NavDropdown.Item as={Link} to="/teamAdmin"> Manage Teams </NavDropdown.Item>)}
                                {roles.includes("club_admin") && (<NavDropdown.Item as={Link} to="/resources/admin">Manage Resources</NavDropdown.Item>)}
                                {(roles.includes("super_admin") || roles.includes("club_admin")) && (<NavDropdown.Item as={Link} to="/resources/bookings">Book Resources</NavDropdown.Item>)}

                                {/* Minis Admin */}
                                {(roles.includes("club_admin") || roles.includes("super_admin")) && <NavDropdown.Divider />}
                                {(roles.includes("club_admin") || roles.includes("super_admin")) && (
                                    <NavDropdown.Item as={Link} to="/minis/admin">Edit Minis Fixtures</NavDropdown.Item>
                                )}

                                {/* --- NEW: Website Embed Link for Club Admins --- */}
                                {roles.includes("club_admin") && <NavDropdown.Divider />}
                                {roles.includes("club_admin") && (
                                    <NavDropdown.Item as={Link} to="/website-embed"> Website Embed Tool </NavDropdown.Item>
                                )}
                                {/* --- END NEW --- */}
                            </NavDropdown>
                        )}
                        {/* --- Optional: New Top-Level "Website" Menu --- */}
                        {/* {roles.includes("club_admin") && (
                             <NavDropdown title="Website" id="website-dropdown">
                                 <NavDropdown.Item as={Link} to="/website-embed">Embed Tool</NavDropdown.Item>
                             </NavDropdown>
                         )} */}
                        {/* --- End Optional Menu --- */}
                    </Nav>
                    <Nav>
                        <SeasonSelector />
                        <Navbar.Text className="me-3"> Signed in as: {user.email} ({roles.join(", ")}) </Navbar.Text>
                        <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;